import React from "react";
import styles from "./styles/reset-button.module.scss";
import CoverTooltip from "@/components/pages/convert/components/cover-tooltip";
import { useStemSplitterContext } from "@/components/pages/stem-splitter/components/providers/stem-splitter-provider";
import UnfilledButton from "@/components/common/unfilled-button";

const ResetButton = () => {
  const { settings, resetCategories } = useStemSplitterContext();
  const areAnyCategoriesSelected = settings.selectedCategories.length > 0;

  return (
    <div
      className={styles.wrapper}
      data-tooltip-id="resetTooltip"
      data-tooltip-content={"Reset all categories"}
    >
      {!areAnyCategoriesSelected && <CoverTooltip id={"resetTooltip"} />}
      <UnfilledButton
        text={"Reset"}
        disabled={!areAnyCategoriesSelected}
        onClick={resetCategories}
        borderColor={"#FF5722"}
        textTransform={"uppercase"}
      />
    </div>
  );
};

export default ResetButton;
